<template src="./html/PaymentCondition.html"></template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-payment-condition'
				},

				loading: false,
				validation: {
					percentage: null,
				},

				origin: null,

				item: {
					title: null,
					main: false,
					description: null,
					main: false,
					payment_conditions: null,
				}
			}
		},
		methods: {
			open(item) {
				if(item) {
					this.origin = item
					this.item = JSON.parse(JSON.stringify(item))
				} else {
					this.clearData()
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.loading = false
				this.errors.clear()
				this.validation.percentage = null
				this.origin = null,
				this.item = {
					title: null,
					main: false,
					description: null,
					main: false,
					payment_conditions: null,
				}
			},
			addPaymentCondition() {
				var payment_condition = {
					title: null,
					description: null,
					percentaje: null,
				}
				if(!Array.isArray(this.item.payment_conditions)) {
					this.item.payment_conditions = []
				}

				this.item.payment_conditions.push(payment_condition)
			},
			destroy(condition) {
				var index = this.item.payment_conditions.indexOf(condition)
				this.$delete(this.item.payment_conditions, index)
			},
			changePercentage(condition) {
				condition.percentage = this.$options.filters.checkDecimals(condition.percentage)
				this.checkPercentage()
			},
			checkPercentage() {
				var sum = 0;
				if(this.item.payment_conditions) {
					if(this.item.payment_conditions.length) {
						this.item.payment_conditions.forEach(function(condition) {
							sum += parseFloat(condition.percentage)
						})
					}
				}

				if(sum == 100) {
					this.validation.percentage = null
					return true
				} else {
					this.validation.percentage = 'La suma de los porcentajes debe ser igual a 100%.'
					return false
				}
			},
			validate() {
				var that = this
				if(!this.checkPercentage()) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.save()
					}
					return result
				})
			},
			save() {
				if(this.item.id) {
					this.update()
				} else {
					this.store()
				}

			},
			store() {
				this.loading = true
				this.$http.post('admin/management/budgets/payment/conditions', this.item)
				.then(response => {
					this.loading = false
					this.reload()
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/management/budgets/payment/conditions/' + this.item.id, this.item)
				.then(response => {
					this.loading = false
					this.reload()
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
				})
			},
			reload() {
				this.$emit('reload')
			},			//---------------------------------------------------------------------------------
			getConditions() {
				this.$http.get('admin/management/budgets/payment/conditions')
					.then(response => {
						this.paymentConditions = response.body
					})
			},
			loadMainCondition() {
				if(this.paymentConditions) {
					if(this.paymentConditions.length) {
						var found = this.paymentConditions.find(function(element) {
							return element.main
						})
						if(found) {
							this.addCondition(found)
						}
					}
				}
			},
			//-- Funcion para añadir un payment, uno nuevo o uno ya existente
			addCondition(payment = null) {
				if(this.item) {
					if(payment) {
						if(payment.payment_conditions) {
							if(payment.payment_conditions.length) {
								var that = this
								payment.payment_conditions.forEach(function(element) {
									var condition = {
										title: element.title,
										description: element.description,
										percentage: element.percentage,
										amount: null,
									}
									that.item.payments.push(condition)
									that.changePercentage(condition)
								})
							}
						}
						this.payment = null
					} else {
						var condition = {
							title: null,
							description: null,
							percentage: null,
							amount: null,
						}
						this.item.payments.push(condition)
					}
					this.calculateTotalPayments()
				}
			},
			//-- Suma de todos los amounts
			calculateTotalPayments() {
				if(this.item) {
					var total = 0
					if(this.item.payments) {
						if(this.item.payments.length) {
							this.item.payments.forEach(function(payment) {
								if(payment.amount) {
									var amount = parseFloat(payment.amount)
								} else {
									var amount = 0
								}

								total = total + amount
							})
						}
					}
					this.item.total = parseFloat(total).toFixed(2)
					this.calculateRest()
				}
			},
			//-- Calculra resto a pagar
			calculateRest() {
				if(this.item) {
					var total_budget = parseFloat(this.total_budget)
					var total = parseFloat(this.item.total)

					var rest = total - total_budget

					if(rest == 0) {
						rest = Math.abs(rest)
					}

					this.rest = parseFloat(rest).toFixed(2)
				}
			},
			//-- Calcular el amount cuando se cambia el porcentaje
			/*
			changePercentage(payment) {
				payment.percentage = this.$options.filters.checkDecimals(payment.percentage)
				var total = this.total_budget
				if(payment.percentage) {
					var percentage = parseFloat(payment.percentage).toFixed(2)
				} else {
					var percentage = 0
				}
				var amount = total * (percentage / 100)
				if(percentage > 100) {
					var amount = -Math.abs(amount)
				}
				payment.amount = parseFloat(amount).toFixed(2)
				this.calculateTotalPayments()
			},
			*/
			//-- Calcular el porcentaje cuando se cambia el amount
			changeAmount(payment) {
				payment.amount = this.$options.filters.checkDecimals(payment.amount)
				var total = parseFloat(this.total_budget)
				if(payment.amount) {
					var amount = parseFloat(payment.amount).toFixed(2)
				} else {
					var amount = 0
				}
				var percentage = amount * 100 / total
				payment.percentage = parseFloat(percentage).toFixed(2)
				this.calculateTotalPayments()
			},
				/*
			save() {
				var loading = Ladda.create(this.$refs.btnSave)
				loading.start()
				this.$http.post('admin/management/budgets/' + this.data.id+ '/payment/conditions', this.item)
				.then(response => {
					loading.stop()
					this.$emit('reload')
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
				*/
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/paymentConditions/views/PaymentCondition.vue